import axios from 'portal/utils/axios-msal'

export const autodeskConfigurationPut = async (
  accountId: string,
  qflowprojectId: string,
  autodeskProjectId: string,
  hubId: string,
  region: string
) => {
  return await axios.put(
    `/accounts/${accountId}/projects/${qflowprojectId}/autodeskconfiguration`,
    {
      hubId,
      projectId: autodeskProjectId,
      region
    }
  )
}

export const autodeskConfigurationDelete = async (
  accountId: string,
  qflowprojectId: string
) => {
  return await axios.delete(
    `/accounts/${accountId}/projects/${qflowprojectId}/autodeskconfiguration`
  )
}
